// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cuwghcwrdjtqylfkdycs.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN1d2doY3dyZGp0cXlsZmtkeWNzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcyOTgwMjIsImV4cCI6MjA1Mjg3NDAyMn0.V0TOBlWTsHkUwZeqvnmpGUpx8rOR0Y-GHZ8PZS-BW9I";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);